const addMarkdownLink = (() => {
  const LINK_LABEL = 'link'

  return (paragraphText, url) => paragraphText
    .replace(LINK_LABEL, `[${LINK_LABEL}](${url})`)
})()

const replaceSpreadsheetParagraph = (() => {
  const SPREADSHEET_HEADLINE = '# Comparison spreadsheet'
  const spreadsheetHeadlineRegexp = new RegExp(`(${SPREADSHEET_HEADLINE})\n[^#]*`)

  return (outro, paragraph) => {
    const outroWithHeadline = outro.includes(SPREADSHEET_HEADLINE)
      ? outro
      : [SPREADSHEET_HEADLINE, outro].join('\n')

    return outroWithHeadline
      .replace(spreadsheetHeadlineRegexp, `$1\n${paragraph}\n`)
  }
})()

export default async function() {
  const paragraphText = await this.generateSpreadsheetParagraphVariant()
  const paragraph = addMarkdownLink(paragraphText, this.article.spreadsheetUrl)
  this.article.outro = replaceSpreadsheetParagraph(this.article.outro, paragraph)
}
